import {
  RegionWithState,
  State,
  Country,
  CountryWithStates,
  StoryWithFeaturedListing,
  Market,
} from '../restApi/types'

type PrehydratedHomePage = {
  country: Country
  states: State[]
  regions: RegionWithState[]
  stories: StoryWithFeaturedListing[]
  currentMarket: Market
  countries: CountryWithStates[]
  fulfillingMomentCount: number
}

export type HomePageState = {
  data: PrehydratedHomePage
}

export type HomePageRootState = {
  home: HomePageState
}

const initialState: HomePageState = {
  data: null,
}

/*
  During serverside rendering, data is placed in the redux store, under keys derived from reducer names.
*/
export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    default:
      return state
  }
}
